// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangePassword_container__NKl51 {
  width: 450px;
  height: 425px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;

  position: absolute;
  top: 92px;
  right: 5px;

  padding: 25px 40px 75px;

  box-shadow: 0px 3px 6px var(--color-theme-gray);
  border: 1px solid var(--color-theme-cloud);

  box-sizing: border-box;
}

.ChangePassword_button_container__WodFL {
  display: flex;
  justify-content: space-between;

  width: 370px;
}

.ChangePassword_btn_cancel__N6Z4t {
  font-weight: bold !important;
  border: 1px solid var(--color-theme-silver) !important;
  color: var(--color-theme-silver);
}

.ChangePassword_btn_confirm__FM1xv {
  font-weight: bold !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
}

.ChangePassword_changePasswordHeader__KoqZb {
  font-size: 22px;
  margin: 0 !important;
  height: 30px;
  color: var(--color-font-2);
  font-weight: bold;
  text-transform: uppercase;
}

.ChangePassword_succsse_message__JXitK {
  width: 100%;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  position: absolute;
  bottom: -1px;
  right: 0px;

  color: var(--color-theme-white);
  font-size: 16px;
  background: var(--color-theme-green);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/ChangePassword/ChangePassword.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;;EAE7B,kBAAkB;EAClB,SAAS;EACT,UAAU;;EAEV,uBAAuB;;EAEvB,+CAA+C;EAC/C,0CAA0C;;EAE1C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;;EAE9B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,sDAAsD;EACtD,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;;EAE7B,kBAAkB;EAClB,YAAY;EACZ,UAAU;;EAEV,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;AACtC","sourcesContent":[".container {\n  width: 450px;\n  height: 425px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-evenly;\n\n  position: absolute;\n  top: 92px;\n  right: 5px;\n\n  padding: 25px 40px 75px;\n\n  box-shadow: 0px 3px 6px var(--color-theme-gray);\n  border: 1px solid var(--color-theme-cloud);\n\n  box-sizing: border-box;\n}\n\n.button_container {\n  display: flex;\n  justify-content: space-between;\n\n  width: 370px;\n}\n\n.btn_cancel {\n  font-weight: bold !important;\n  border: 1px solid var(--color-theme-silver) !important;\n  color: var(--color-theme-silver);\n}\n\n.btn_confirm {\n  font-weight: bold !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n}\n\n.changePasswordHeader {\n  font-size: 22px;\n  margin: 0 !important;\n  height: 30px;\n  color: var(--color-font-2);\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.succsse_message {\n  width: 100%;\n  height: 55px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n\n  position: absolute;\n  bottom: -1px;\n  right: 0px;\n\n  color: var(--color-theme-white);\n  font-size: 16px;\n  background: var(--color-theme-green);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChangePassword_container__NKl51`,
	"button_container": `ChangePassword_button_container__WodFL`,
	"btn_cancel": `ChangePassword_btn_cancel__N6Z4t`,
	"btn_confirm": `ChangePassword_btn_confirm__FM1xv`,
	"changePasswordHeader": `ChangePassword_changePasswordHeader__KoqZb`,
	"succsse_message": `ChangePassword_succsse_message__JXitK`
};
export default ___CSS_LOADER_EXPORT___;
